<!-- ni-autocomplete.component.html -->
<div #containerRef class="ni-autocomplete-container" [class.w-full]="fluid" [class.opacity-60]="disabled"
  [class.pointer-events-none]="disabled" [style]="style" [class]="styleClass"
  [attr.aria-label]="getAriaLabel()" [attr.aria-labelledby]="getAriaLabelledBy()"
  [attr.aria-describedby]="getAriaDescribedBy()" [attr.aria-controls]="getAriaControls()"
  [attr.aria-expanded]="getAriaExpanded()" [attr.aria-autocomplete]="getAriaAutoComplete()"
  [attr.aria-haspopup]="getAriaHasPopup()" [attr.aria-activedescendant]="getAriaActiveDescendant()"
  (focus)="focusContainer()" (blur)="onInputBlur()" (keydown)="handleKeyDown($event)" (keyup)="onKeyUp($event)" [tooltip]="tooltip" [position]="tooltipPosition"
  [alwaysVisible]="tooltipEvent === 'always'" [theme]="tooltipTheme">
  <!-- Label -->
  <label *ngIf="label" class="ni-autocomplete-label" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="ni-autocomplete-required">*</span>
  </label>

  <!-- Main Input Container -->
  <div class="ni-input-container">

    <!-- Multiple Selection Container -->
    <div *ngIf="multiple" [class]="getContainerClasses()">
      <div *ngIf="shouldShowLeadingIconMultiple()" class="ni-leading-icon ni-leading-icon--multiple"
        (click)="handleLeadingIconClick($event)" (keydown)="handleLeadingIconClick($event)">
        <NiIcon [icon]="leadingIcon" [class]="leadingIconClass"></NiIcon>
      </div>
      <div class="ni-multiple-content">
        <!-- Chips Container -->
        <div *ngIf="selectedOptions.length > 0" #chipsContainerRef
          [class]="'ni-chips-container' + (hasError ? ' error' : '')" (click)="handleChipsContainerClick($event)" (keydown)="handleChipsContainerClick($event)">
          <div *ngFor="let option of getVisibleChips(); trackBy: trackByValue" data-chip-item
            class="ni-chip cursor-pointer" (click)="handleChipClick($event, option)" (keydown)="handleChipClick($event, option)">
            <!-- Profile Image in Chip -->
            <div *ngIf="option['profileImage']" class="ni-chip-profile-image flex-shrink-0">
              <img [src]="option['profileImage']" [alt]="getOptionLabel(option)"
                class="w-5 h-5 rounded-full object-cover" loading="lazy" decoding="async" (error)="onImageError($event, option, 'profileImage')"
                [style.display]="option['imageLoaded'] !== false ? 'block' : 'none'">
              <div *ngIf="option['imageLoaded'] === false"
                class="w-5 h-5 rounded-full bg-primary-400 flex items-center justify-center text-white font-medium text-xs">
                {{ getFirstLetter(option) }}
              </div>
            </div>
            <span class="truncate min-w-0 flex-1">{{ getOptionLabel(option) }}</span>
            <button type="button" class="ni-chip-remove flex-shrink-0"
              (click)="removeItem(option); $event.stopPropagation();"
              [attr.aria-label]="'Remove ' + getOptionLabel(option)">
              <NiIcon [icon]="clearIcon" class="ni-chip-remove-icon"></NiIcon>
            </button>
          </div>
          <!-- Overflow Indicator -->
          <span *ngIf="getHiddenChipsCount() > 0" class="ni-overflow-indicator">...</span>
          <div *ngIf="getHiddenChipsCount() > 0" class="ni-chip-count" (click)="handleCountChipClick($event)" (keydown)="handleCountChipClick($event)">
            <span>+{{ getHiddenChipsCount() }}</span>
          </div>
        </div>

        <!-- Placeholder -->
        <div *ngIf="selectedOptions.length === 0" [class]="'ni-chips-placeholder' + (hasError ? ' error' : '')"
          (click)="handlePlaceholderClick($event)" (keydown)="handlePlaceholderClick($event)">
          {{ placeholder || 'Choose a tag...' }}
        </div>
      </div>
    </div>
    <!-- 🔒 Hidden Measurement Container (for chip width calculation only) -->
    <div #chipMeasureRef class="absolute opacity-0 pointer-events-none"
      style="position: absolute; visibility: hidden; height: 0; overflow: hidden;">
      <div *ngFor="let option of selectedOptions" class="ni-chip" data-measure-chip>
        <!-- Profile Image in Measurement Chip -->
        <div *ngIf="option['profileImage']" class="ni-chip-profile-image flex-shrink-0">
          <img [src]="option['profileImage']" [alt]="getOptionLabel(option)" class="w-5 h-5 rounded-full object-cover"
            loading="lazy" decoding="async" (error)="onImageError($event, option, 'profileImage')"
            [style.display]="option['imageLoaded'] !== false ? 'block' : 'none'">
          <div *ngIf="option['imageLoaded'] === false"
            class="w-5 h-5 rounded-full bg-primary-400 flex items-center justify-center text-white font-medium text-xs">
            {{ getFirstLetter(option) }}
          </div>
        </div>
        <span class="truncate min-w-0 flex-1">{{ getOptionLabel(option) }}</span>
        <button type="button" class="ni-chip-remove flex-shrink-0">
          <NiIcon [icon]="clearIcon" class="ni-chip-remove-icon"></NiIcon>
        </button>
      </div>
    </div>

    <!-- Single Selection Input -->
    <div *ngIf="!multiple" class="ni-single-container">
      <div class="ni-input-wrapper relative w-full" (click)="onInputWrapperClick($event)" (keydown)="onInputWrapperClick($event)">
        <!-- Profile Image for Single Select -->
        <div *ngIf="selectedOptions.length > 0 && selectedOptions[0]?.['profileImage']" class="ni-single-profile-image"
          (mousedown)="onProfileImageMouseDown($event)" (click)="onProfileImageClick($event)" (keydown)="onProfileImageClick($event)">
          <img [src]="selectedOptions[0]['profileImage']" [alt]="getOptionLabel(selectedOptions[0])"
            class="w-6 h-6 rounded-full object-cover border border-secondary-300 cursor-pointer"
            loading="lazy" decoding="async"
            (error)="onImageError($event, selectedOptions[0], 'profileImage')"
            [style.display]="selectedOptions[0]['imageLoaded'] !== false ? 'block' : 'none'">
          <div *ngIf="selectedOptions[0]['imageLoaded'] === false"
            class="w-6 h-6 rounded-full bg-primary-500 flex items-center justify-center text-white font-medium text-sm border border-primary-500 cursor-pointer">
            {{ getFirstLetter(selectedOptions[0]) }}
          </div>
        </div>
        <div *ngIf="shouldShowLeadingIconSingle()" class="ni-leading-icon ni-leading-icon--single pl-[8px]"
          (mousedown)="onInputMouseDown($event)" (click)="handleLeadingIconClick($event)" (keydown)="handleLeadingIconClick($event)">
          <NiIcon [icon]="leadingIcon" [class]="leadingIconClass"></NiIcon>
        </div>
        <input #inputRef [type]="inputType" [id]="inputId" [placeholder]="placeholder" [value]="getInputValue()"
          [disabled]="disabled" [readonly]="readonly && !typeahead" [tabindex]="tabindex" [style]="inputStyle"
          [class]="inputStyleClass" [class.error]="hasError"
          [class.ni-input-with-image]="selectedOptions.length > 0 && selectedOptions[0]?.['profileImage']"
          [class.ni-input-with-leading-icon]="shouldShowLeadingIconSingle()" [attr.maxlength]="maxLength"
          [attr.pattern]="inputPattern"
          class="ni-input-field w-full bg-transparent border-0 shadow-none outline-none flex-1" niTooltip
          [tooltip]="tooltip" [position]="tooltipPosition" [alwaysVisible]="tooltipEvent === 'always'"
          (click)="onInputClick($event)" (mousedown)="onInputMouseDown($event)" (input)="onInputChange($event)"
          (keydown)="handleKeyDown($event)" (focus)="onInputFocus()" (blur)="onInputBlur()" autocomplete="off">
      </div>
    </div>

    <!-- Buttons Container -->
    <div class="absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center gap-1">
      <!-- Clear Button -->
      <button
        *ngIf="showClearButton && !loading && ((!multiple && selected) || (multiple && selectedOptions.length > 0) || getDisplayValue().length > 0 || query.length > 0)"
        type="button"
        class="w-5 h-5 rounded-full bg-primary-500 hover:bg-primary-600 flex items-center justify-center transition-all duration-150 cursor-pointer !static !transform-none"
        [attr.aria-label]="'Clear selection'" (click)="clearSelection($event)">
        <NiIcon [icon]="clearIcon" [class]="clearIconClass"></NiIcon>
      </button>
      <NiIcon *ngIf="shouldShowTrailingIcon()" [icon]="trailingIcon" [class]="trailingIconClass + ' ni-trailing-icon'"
        (click)="handleTrailingIconClick($event)" (keydown)="handleTrailingIconClick($event)"></NiIcon>

      <!-- Dropdown Button -->
      <button *ngIf="showDropdownIcon" type="button" class="ni-dropdown-button !static !transform-none"
        [attr.aria-label]="'Toggle dropdown'" [attr.aria-expanded]="getAriaExpanded()"
        (click)="handleDropdownClick($event)">
        <NiIcon [icon]="dropdownIcon" class="ni-dropdown-button-icon" [class.rotate-180]="showOptions"></NiIcon>
      </button>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="loading" class="ni-loading-container">
      <div class="ni-loading-spinner"></div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError && errorMessage" class="ni-error-message">
    <NiIcon *ngIf="errorIcon" [icon]="errorIcon" class="ni-error-icon"></NiIcon>
    {{ errorMessage }}
  </div>



  <!-- Options Dropdown -->
  <div #optionsRef *ngIf="showOptions" [class]="getOptionsDropdownClasses()" @dropDownMenu (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
    <!-- Action Section (Top) -->
    <div *ngIf="showActionSection && actionSectionPosition === 'top' && actionButtons.length > 0"
      class="ni-action-section ni-action-section-top" (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <div class="ni-action-buttons" [ngClass]="{
        'ni-action-buttons-left': actionSectionAlignment === 'left',
        'ni-action-buttons-center': actionSectionAlignment === 'center',
        'ni-action-buttons-right': actionSectionAlignment === 'right'
      }">
        <button *ngFor="let button of actionButtons" type="button" class="ni-action-button"
          [class.ni-action-button-primary]="button.variant === 'primary'"
          [class.ni-action-button-secondary]="button.variant === 'secondary'"
          [class.ni-action-button-danger]="button.variant === 'danger'"
          [class.ni-action-button-success]="button.variant === 'success'"
          [class.ni-action-button-disabled]="button.disabled" [disabled]="button.disabled"
          (click)="onActionButtonClick(button.action, $event)">
          <div class="flex gap-2 items-center  justify-center">
            <NiIcon *ngIf="button.icon" [icon]="button.icon" class="ni-action-button-icon"></NiIcon>
            <span class="ni-action-button-label">{{ button.label }}</span>
          </div>
        </button>
      </div>
    </div>

    <!-- Search Input -->
    <div *ngIf="multiple" class="ni-dropdown-search-container " (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <input #dropdownSearchRef [type]="inputType" [(ngModel)]="query" (input)="filterOptions()"
        (mousedown)="onDropdownSearchInputMouseDown()" (focus)="onDropdownSearchInputFocus()"
        [attr.maxlength]="maxLength" [attr.pattern]="inputPattern" niTooltip [tooltip]="tooltip"
        [position]="tooltipPosition" [theme]="tooltipTheme" [alwaysVisible]="tooltipEvent === 'always'"
        placeholder="Search..." class="ni-dropdown-search-input" />
    </div>

    <!-- Options List -->
    <div class="options-list-container" (scroll)="onOptionsPanelScroll($event)" (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <ng-container *ngIf="!loading">
        <!-- Grouped Options -->
        <div *ngIf="group && filteredGroups.length > 0">
          <div *ngFor="let group of filteredGroups; trackBy: trackByValue">
            <div class="ni-group-header">{{ group.label }}</div>
            <ng-container *ngFor="let option of group.items; trackBy: trackByValue; let index = index">
              <div class="menu-item">
                <ni-option [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                  [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                  [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                  (favoriteToggle)="onFavoriteToggle($event)"
                  (imageError)="onImageError($event.event, $event.option, $event.type)">
                </ni-option>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- Regular Options with Favorites -->
        <div *ngIf="!group && filteredOptions.length > 0 && showFavoriteToggle">
          <!-- Favorites Section -->
          <div *ngIf="favoriteFilteredOptions.length > 0" class="ni-favorites-section">
            <div class="ni-favorites-header">
              <span class="ni-favorites-label">FAVORITES</span>
            </div>
          </div>

          <ng-container *ngFor="let option of favoriteFilteredOptions; trackBy: trackByValue; let index = index">
            <div class="menu-item">
              <ni-option [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                (favoriteToggle)="onFavoriteToggle($event)"
                (imageError)="onImageError($event.event, $event.option, $event.type)">
              </ni-option>
            </div>
          </ng-container>

          <!-- Separator between favorites and regular options -->
          <div *ngIf="favoriteFilteredOptions.length > 0 && nonFavoriteFilteredOptions.length > 0" class="ni-separator">
          </div>

          <!-- Non-Favorite Section -->
          <ng-container *ngFor="let option of nonFavoriteFilteredOptions; trackBy: trackByValue; let index = index">
            <div class="menu-item">
              <ni-option [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                (favoriteToggle)="onFavoriteToggle($event)"
                (imageError)="onImageError($event.event, $event.option, $event.type)">
              </ni-option>
            </div>
          </ng-container>
        </div>

        <!-- Regular Options without Favorites (fallback) -->
        <div *ngIf="!group && filteredOptions.length > 0 && !showFavoriteToggle" class="p-2">
          <ng-container *ngFor="let option of filteredOptions; trackBy: trackByValue; let index = index">
            <div >
              <ni-option [option]="option" [multiple]="multiple" [selected]="isOptionSelected(option)"
                [highlighted]="highlightedIndex === index" [optionLabel]="optionLabel" [checkIcon]="checkIcon"
                [showFavoriteToggle]="showFavoriteToggle" [showBadge]="showBadge" (optionClick)="selectOption($event)"
                (favoriteToggle)="onFavoriteToggle($event)"
                (imageError)="onImageError($event.event, $event.option, $event.type)">
              </ni-option>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <!-- Loading/Empty Messages -->
    <div *ngIf="loading" class="ni-loading-message menu-item flex items-center justify-center gap-2" (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <div class="ni-loading-spinner"></div>
      <span class="ni-loading-text text-secondary-500 text-sm text-center">Loading...</span>
    </div>
    <div *ngIf="!loading && filteredOptions.length === 0 && !group" class="ni-empty-message menu-item" (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <span class="ni-loading-text">No data found</span>
    </div>

    <!-- Action Section (Bottom) -->
    <div *ngIf="showActionSection && actionSectionPosition === 'bottom' && actionButtons.length > 0"
      class="ni-action-section ni-action-section-bottom" (click)="onOptionsPanelClick($event)" (mousedown)="onOptionsPanelMouseDown($event)" (dblclick)="onOptionsPanelDoubleClick($event)" (keydown)="onOptionsPanelKeyDown($event)" (keyup)="onOptionsPanelKeyUp($event)" (keypress)="onOptionsPanelKeyPress($event)">
      <div class="ni-action-buttons" [ngClass]="{
        'ni-action-buttons-left': actionSectionAlignment === 'left',
        'ni-action-buttons-center': actionSectionAlignment === 'center',
        'ni-action-buttons-right': actionSectionAlignment === 'right'
      }">
        <button *ngFor="let button of actionButtons" type="button" class="ni-action-button"
          [class.ni-action-button-primary]="button.variant === 'primary'"
          [class.ni-action-button-secondary]="button.variant === 'secondary'"
          [class.ni-action-button-danger]="button.variant === 'danger'"
          [class.ni-action-button-success]="button.variant === 'success'"
          [class.ni-action-button-disabled]="button.disabled" [disabled]="button.disabled"
          (click)="onActionButtonClick(button.action, $event)">
          <div class="flex gap-2 items-center  justify-center">
            <NiIcon *ngIf="button.icon" [icon]="button.icon" class="ni-action-button-icon"></NiIcon>
            <span class="ni-action-button-label">{{ button.label }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>